import { getDefaultExperiments, getExperimentsFromHeaders } from '../utils'

/**
 * Get all experiments from request headers. This function is designed to work
 * in Nitro context where `useRequestHeaders` is not available.
 *
 * @example - Nitro
 * import { getRequestHeaders } from 'h3'
 * import { getExperiments } from '@backmarket/nuxt-module-experiments/getExperiments'
 * const headers = getRequestHeaders(event)
 * const experiments = getRequestExperiments(headers)
 */
export function getRequestExperiments(
  headers: Record<string, string | undefined>,
): Record<string, string> {
  const defaultExperiments = getDefaultExperiments()
  const customExperiments = getExperimentsFromHeaders(headers)

  return {
    ...defaultExperiments,
    ...customExperiments,
  }
}
